import styled from "styled-components";

const Container = styled.span`
    font-weight: bold;
    font-size: 2.5rem;
    line-height: 1.6rem;
    display: inline-block;
    padding-bottom: 1rem;

    small {
        font-weight: 555;
        font-size: 1.5rem;
    }
`;

const VirtualTourInfoTitle = () => {
    return (
        <Container>
            <small>Tour virtual 3D</small><br />
            Matterport
        </Container>
    );
};

export default VirtualTourInfoTitle;
